interface ConsultantData {
  name: string
  loanName: string
  phoneCode: string
  phoneNo: string
  email: string
}

export const ConsultantData: Readonly<ConsultantData> = {
  // translated value
  name: 'consultant',
  loanName: 'loanConsultant',
  phoneCode: '+48',
  phoneNo: '459599677',
  email: 'biuro@wesub.pl',
}
